<ng-container *ngIf="dataLoaded">
    <div class="modal-body" *ngIf="nmvtisMessageModel?.nmvtisResponse">
        <h2>NMVTIS Results</h2>
        <table class="mvd_table--primeng">
            <thead>
                <tr>
                    <th>VIN</th>
                    <th>Year</th>
                    <th>Make</th>
                    <th>Odometer Reading</th>
                    <th>SOT</th>
                    <th>Title Number</th>
                    <th>Title Issue Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let vehicle of vehicleNoTitleHistoryList">
                    <td>{{vehicle.vehicleIdentification}}</td>
                    <td>{{vehicle.itemModelYearDate}}</td>
                    <td>{{vehicle.vehicleMakeCode}}</td>
                    <td>{{vehicle.vehicleOdometerReadingMeasure}}</td>
                    <td>{{vehicle.titleIssuingAuthorityName}}</td>
                    <td>{{vehicle.titleIdentification}}</td>
                    <td>{{vehicle.titleIssueDate | shortDate}}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="modal-footer">
        <div class="btn--group">
            <button class="btn--primary" type="submit" (click)="onSaveClick()">Continue</button>
        </div>
    </div>
</ng-container>